import React from 'react';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';

import { useAppDispatch, useTranslation } from 'client/hooks';
import { Button } from 'client/components/common/mobile';
import { category as categoryApi } from 'client/redux/api/category';

import css from './Hero.module.scss';
import { setPopup } from 'client/redux/ui';
import { selectAuth } from 'client/redux/user/selectors';
import { useAppSelector } from 'client/hooks/redux';
import GoforisraelBtn from '../../Category/GoforisraelBtn';

interface Props {
  className?: string;
  containerRef?: React.RefObject<HTMLDivElement>;
}

const Hero: React.FC<Props> = (props) => {
  const { className = '' } = props;
  const auth = useAppSelector(selectAuth);
  const { translate } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();

  const urlParams = new URLSearchParams(history.location.search);
  const categoryId = urlParams.get('category') || '';
  const { data: categoryData, isFetching: isCategoryFetching } = categoryApi.endpoints.getCategory.useQuery(
    {
      id: categoryId || '',
    },
    { skip: !categoryId }
  );
  const category = React.useMemo(() => (categoryData?.success ? categoryData.data : null), [categoryData]);
  const isGoForIsraelCategory = categoryId === 'goforisrael';

  const onJoinClick = () => {
    dispatch(setPopup({ type: 'auth', data: { initialAuthType: 'sign-up' } }));
  };

  const onLoginBtnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    dispatch(setPopup({ type: 'auth', data: { initialAuthType: 'sign-in' } }));
  };

  const renderTopContent = () => {
    return categoryId && category && !isCategoryFetching ? (
      <>
        <h1 className={css.heading}>{category.name}</h1>
        <p className={css.subHeading}>
          {category.descriptionMobile ? category.descriptionMobile : category.description}
        </p>
        {isGoForIsraelCategory && <GoforisraelBtn />}
      </>
    ) : (
      <>
        <h1 className={css.heading} dangerouslySetInnerHTML={{ __html: translate('mainPage.heading') }} />
        <p className={css.subHeading} dangerouslySetInnerHTML={{ __html: translate('mainPage.subHeadingMobile') }} />
        {auth.isLoggedIn === false && (
          <>
            <Button className={css.joinBtn} onClick={onJoinClick} size="large" variant="primary">
              <span>{translate('mainPage.joinBtnLabel')}</span>
            </Button>

            <a href="#" className={css.loginBtn} onClick={onLoginBtnClick}>
              {translate('mainPage.loginBtnLabel')}
            </a>
          </>
        )}
      </>
    );
  };

  return (
    <div className={cn(css.hero, className)} ref={props.containerRef}>
      {renderTopContent()}
    </div>
  );
};

export default Hero;
